export default __webpack_public_path__ + "static/media/tmf-portal-background-optimized.1e956388.jpg";